const KEY = 'superfeo_saved_tickets_v1';

function isPersistable(booking) {
  if (!booking?.reference && !booking?.tripId) return false;
  const s = String(booking.status || '').toLowerCase();
  return s === 'paid' || s === 'confirmed' || s === 'ticketed' || s.includes('paid');
}

export function loadLocalTickets() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return [];
    const list = JSON.parse(raw);
    if (!Array.isArray(list)) return [];
    return list.filter((b) => b && (b.reference || b.tripId));
  } catch {
    return [];
  }
}

export function saveLocalTickets(tickets) {
  localStorage.setItem(KEY, JSON.stringify(tickets || []));
}

export function upsertLocalTicket(booking) {
  if (!isPersistable(booking)) return loadLocalTickets();
  const current = loadLocalTickets();
  const ref = String(booking.reference || '');
  const tripId = booking.tripId != null ? String(booking.tripId) : '';
  const next = current.filter((b) => {
    if (ref && b.reference === ref) return false;
    if (tripId && String(b.tripId || '') === tripId) return false;
    return true;
  });
  next.unshift({ ...booking, savedAt: new Date().toISOString() });
  saveLocalTickets(next.slice(0, 50));
  return next.slice(0, 50);
}

export function removeLocalTicket(reference) {
  const ref = String(reference || '');
  const next = loadLocalTickets().filter((b) => b.reference !== ref);
  saveLocalTickets(next);
  return next;
}

export function mergeTickets(localList, remoteList) {
  const map = new Map();
  const score = (b) => {
    const t = b.savedAt || b.expireDateTime || '';
    return String(t);
  };
  for (const b of [...(remoteList || []), ...(localList || [])]) {
    if (!b) continue;
    const key = b.reference || b.tripId;
    if (!key) continue;
    const prev = map.get(key);
    if (!prev || score(b) >= score(prev)) map.set(key, b);
  }
  return Array.from(map.values()).sort((a, b) =>
    String(b.savedAt || '').localeCompare(String(a.savedAt || ''))
  );
}

export { isPersistable };
